import { DrawerHeader, IconButton } from '@one-thd/sui-atomic-components';
import { Close, ArrowBack } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { SubmitSuspendCartRequest, } from '../../../api/oms/edit-pickup-location';
import { getWindow } from '../../../utils/general';
import '../../../styles/drawer.scss';
import { EditPickupLocationStoreSelection } from './EditPickupLocationStoreSelection';
import { EditPickupLocationConfirmation } from './EditPickupLocationConfirmation';
import { EditPickupLocationSurvey } from './EditPickupLocationSurvey';
import { useExperienceContext, useOrderContext, useFulfillmentGroupContext, useEditPickupLocationContext, } from '../../../hooks/useContexts';
import { catchEditPickupLocationButtonClick } from '../../../utils/edit-pickup-location/analytics';
import { EditPickupLocationGetStoreLocations } from '../../../api/omm/edit-pickup-location';
import { getFlowTypeValue } from '../util/OutOfStock';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { TrackBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
export var EditPickupLocationDrawer = function (_a) {
    var _b, _c;
    var setOpen = _a.setOpen, isBopisOutOfStock = _a.isBopisOutOfStock, isOuterClick = _a.isOuterClick, setIsOuterClick = _a.setIsOuterClick;
    var _d = useFulfillmentGroupContext(), fulfillmentGroup = _d.fulfillmentGroup, fulfillmentType = _d.fulfillmentType, fulfillmentGroupIndex = _d.fulfillmentGroupIndex;
    var _e = useOrderContext(), orderDetailsData = _e.orderDetailsData, orderId = _e.orderId, currentBopisOosDrawer = _e.currentBopisOosDrawer, setCurrentBopisOosDrawer = _e.setCurrentBopisOosDrawer, setShowDrawerError = _e.setShowDrawerError;
    var _f = useEditPickupLocationContext(), isLocationChangeConfirmed = _f.isLocationChangeConfirmed, setIsLocationChangeConfirmed = _f.setIsLocationChangeConfirmed, isConfirmation = _f.isConfirmation, setIsConfirmation = _f.setIsConfirmation, isStoreSelection = _f.isStoreSelection, setIsStoreSelection = _f.setIsStoreSelection, selectedStoreData = _f.selectedStoreData, editPickupLocationOrderIds = _f.editPickupLocationOrderIds, setStoreLocationData = _f.setStoreLocationData, setSkeletonLoading = _f.setSkeletonLoading;
    var emailId = orderDetailsData.emailId, net = orderDetailsData.net;
    var _g = useState(null), alertState = _g[0], setAlertState = _g[1];
    var _h = useState(false), isSurvey = _h[0], setIsSurvey = _h[1];
    var _j = useState(), suspendCartData = _j[0], setSuspendCartData = _j[1];
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isIos = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac')) || false;
    var isIosMobile = isIos && isConsumerApp;
    var fulfillmentTypeCode = ((_c = convertedFulfillmentTypes(fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || undefined;
    var suspendCartCheck = function () {
        if (suspendCartData && !isLocationChangeConfirmed) {
            SubmitSuspendCartRequest(suspendCartData, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId);
            setSuspendCartData(undefined);
        }
    };
    var closeDrawer = function () {
        var _a, _b;
        // Reset outer click
        setIsOuterClick(false);
        if (currentBopisOosDrawer) {
            setCurrentBopisOosDrawer('');
        }
        setOpen(false);
        setIsConfirmation(false);
        setIsSurvey(false);
        setIsStoreSelection(true);
        suspendCartCheck();
        if (isLocationChangeConfirmed) {
            setIsLocationChangeConfirmed(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
    };
    var goBack = function () {
        if (currentBopisOosDrawer && isStoreSelection) {
            setCurrentBopisOosDrawer('');
            return;
        }
        if (isConfirmation) {
            setIsConfirmation(false);
            setIsStoreSelection(true);
            suspendCartCheck();
            return;
        }
        closeDrawer();
    };
    useEffect(function () {
        var _a;
        var onBeforeUnload = function () {
            suspendCartCheck();
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener('beforeunload', onBeforeUnload);
            suspendCartCheck();
        };
    }, []);
    useEffect(function () {
        if (selectedStoreData) {
            setSuspendCartData({
                cartId: selectedStoreData.storeInfo.newOrder.cartId,
                orderId: orderId,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                fulfillmentType: fulfillmentTypeCode,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
                flowType: getFlowTypeValue(currentBopisOosDrawer, FLOW_TYPES.EDIT_PICKUP_LOCATION),
            });
            setIsStoreSelection(false);
            setIsConfirmation(true);
        }
    }, [selectedStoreData]);
    useEffect(function () {
        var _a;
        if (editPickupLocationOrderIds) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('editPickupLocationOrderIds', JSON.stringify(editPickupLocationOrderIds));
        }
    }, [editPickupLocationOrderIds]);
    var getStoreLocations = function (storeZipNumber) {
        var _a, _b, _c, _d, _e;
        if (currentBopisOosDrawer !== 'STORE_PICKUP_OPTION') {
            catchEditPickupLocationButtonClick();
        }
        var request = {
            orderId: orderId,
            currentStoreId: (_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number,
            keyword: storeZipNumber || ((_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _c === void 0 ? void 0 : _c.store) === null || _d === void 0 ? void 0 : _d.number),
            emailId: emailId,
            currentFulfillmentType: fulfillmentTypeCode,
            net: net,
            onlineSkus: (_e = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) === null || _e === void 0 ? void 0 : _e.filter(function (lineItem) { return !lineItem.isAssembly; }).map(function (lineItem) {
                var _a, _b;
                return ({
                    number: (_a = lineItem.omsId) === null || _a === void 0 ? void 0 : _a.toString(),
                    quantity: Number(currentBopisOosDrawer === 'STORE_PICKUP_OPTION'
                        ? (_b = lineItem.originalOrderedQuantity) !== null && _b !== void 0 ? _b : lineItem.orginalOrderedQuantity
                        : lineItem.currentQuantity), // orderDetailsResponse.fulfillmentGroups[?].lineItems[?].currentQuantity
                });
            }),
            flowType: getFlowTypeValue(currentBopisOosDrawer, FLOW_TYPES.EDIT_PICKUP_LOCATION),
        };
        var traceId = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId;
        EditPickupLocationGetStoreLocations(request, setStoreLocationData, setOpen, setSkeletonLoading, setShowDrawerError, fulfillmentGroupIndex, traceId, setAlertState);
    };
    useEffect(function () {
        if (currentBopisOosDrawer === 'STORE_PICKUP_OPTION') {
            TrackBopisOosrAnalytics('out of stock review your options: edit pickup location', 'overlay');
        }
        getStoreLocations();
    }, []);
    useEffect(function () {
        if (isOuterClick) {
            closeDrawer();
        }
    }, [isOuterClick]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { title: "Edit Pickup Location", startAdornment: (!isStoreSelection || currentBopisOosDrawer) &&
                !isSurvey && (React.createElement(IconButton, { "aria-label": "go-back", onClick: function () { return goBack(); }, icon: ArrowBack })), endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: closeDrawer, icon: Close }) }),
        isStoreSelection && (React.createElement(EditPickupLocationStoreSelection, { closeDrawer: closeDrawer, getStoreLocations: getStoreLocations, alertState: alertState })),
        isConfirmation && selectedStoreData && (React.createElement(EditPickupLocationConfirmation, { closeDrawer: closeDrawer, setIsSurvey: setIsSurvey, suspendCartCheck: suspendCartCheck, isIosMobile: isIosMobile })),
        isSurvey && (React.createElement(EditPickupLocationSurvey, { closeDrawer: closeDrawer, isIosMobile: isIosMobile, isBopisOutOfStock: isBopisOutOfStock }))));
};
